import { render, staticRenderFns } from "./installStep5.vue?vue&type=template&id=5539cbfb&scoped=true"
import script from "./installStep5.vue?vue&type=script&lang=js"
export * from "./installStep5.vue?vue&type=script&lang=js"
import style0 from "./installStep5.vue?vue&type=style&index=0&id=5539cbfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539cbfb",
  null
  
)

export default component.exports